import { render, staticRenderFns } from "./officialAccountsDialog.vue?vue&type=template&id=5b34ffd2&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./officialAccountsDialog.vue?vue&type=style&index=0&id=5b34ffd2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b34ffd2",
  null
  
)

export default component.exports